const getCurrentProjectId = (): string => {
  const { pathname } = window.location;
  return pathname.split('/')[2];
};

export default getCurrentProjectId;
